import { render, staticRenderFns } from "./Ayuda.vue?vue&type=template&id=fcc6f338&scoped=true&"
import script from "./Ayuda.vue?vue&type=script&lang=js&"
export * from "./Ayuda.vue?vue&type=script&lang=js&"
import style0 from "./Ayuda.vue?vue&type=style&index=0&id=fcc6f338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc6f338",
  null
  
)

export default component.exports